<template>
  <div class="collapse show collapse-horizontal aside col-lg-2" id="collapseWidthExample">
    <div class="aside-inner">
      <div class="aside-inner-title">설정</div>
      <div class="accordion" id="accordionExample">
        <template v-for="depth1 in state.SnbDepth1" :key="depth1.key" >
            <template v-if="depth1.access">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <ElButton v-if="!depth1.link" type="accordionSide" :target="depth1.key" :active="isCollapseShow(depth1.showMenuId)">
                    {{ depth1.name }}
                  </ElButton>

                  <router-link 
                    v-else
                    :to="depth1.link"
                  >
                    <ElButton 
                      :type="state.keyStatus === depth1.key ? 'sideBtnActive' : 'sideBtnNonActive'"
                    >
                        {{ depth1.name }}
                    </ElButton>
                  </router-link>
                </h2>
                <div :id="depth1.key" :class="[isCollapseShow(depth1.showMenuId)? 'accordion-collapse collapse show' : 'accordion-collapse collapse']">
                  <div class="accordion-body">
                    <ul class="accordion-submenu">
                      <template v-for="item in state.snbDepth2" :key="item.key">
                        <li v-if="item.access && depth1.key == item.key">
                          <router-link 
                            :class="checkActive(item)"
                            :to="item.link"
                          >
                            {{ item.name }}
                          </router-link>
                        </li>
                      </template>

                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </template> 
      </div>
    </div>      
  </div>
 
</template>

<script setup>
import { router } from '@/router';
import {computed} from 'vue'
import { useRoute } from "vue-router";
import { useUserStore } from '@/store/user';
const route = useRoute()
const userStore = useUserStore()


const state = computed(()=>{
  const data = {
    SnbDepth1 :[
        {key : 'cf1',name:'영업기회 설정', link : '',id:'M007M001',access:false,showMenuId:['MCF_SC_001','MCF_SC_002','MCF_SC_005','MCF_SC_007','MCF_SC_004','MCF_SC_008']},
        {key : 'cf2',name:'사용자 관리', link : '',id:'M007M002',access:false,showMenuId:['MCF_US_001','MCF_US_002','MCF_US_003','MCF_US_004']},
        {key : 'cf3',name:'부서 관리', link : '/cf/MCF_DP_001',id:'M007M003',access:false},
        {key : 'cf4',name:'화면 메뉴 관리', link : '/cf/MCF_MN_001',id:'M007M004',access:false},
        {key : 'cf5',name:'화면 권한 관리', link : '/cf/MCF_PR_001',id:'M007M005',access:false},
        {key : 'cf6',name:'코드 관리', link : '/cf/MCF_CD_001',id:'M007M006',access:false},
        {key : 'cf7',name:'알림결과 조회', link : '/cf/MCF_AM_001',id:'M007M007',access:false},
        {key : 'cf8',name:'배치 관리', link : '',id:'M007M008',access:false,showMenuId:['MCF_BT_001','MCF_BT_003']},
        {key : 'cf9',name:'News&Notice관리', link : '',id:'M007M009',access:false,showMenuId:['MCF_NT_001','MCF_NT_002']},
    ],
    snbDepth2 : [
        {key : 'cf1',name:'영업기회 속성관리',            link : '/cf/MCF_SC_001',id:'M007M001M001',access:false},
        {key : 'cf1',name:'영업기회 Quota 등록/수정',          link : '/cf/MCF_SC_002',id:'M007M001M002',access:false},
        {key : 'cf1',name:'영업기회 Quota 조회',      link : '/cf/MCF_SC_007',id:'M007M001M003',access:false},
        {key : 'cf1',name:'Account 매핑테이블 등록/수정', link : '/cf/MCF_SC_004',id:'M007M001M004',access:false},
        {key : 'cf1',name:'Account 매핑테이블 조회', link : '/cf/MCF_SC_008',id:'M007M001M005',access:false},
        // {key : 'cf1',name:'Account 매핑테이블 이력', link : '/cf/MCF_SC_006',id:'',access:false},

        {key : 'cf2',name:'사용자 조회', link : '/cf/MCF_US_001',id:'M007M002M002',access:false},
        {key : 'cf2',name:'사용자 등록/수정', link : '/cf/MCF_US_002',id:'M007M002M001',access:false,activeLink : ['/cf/MCF_US_002','/cf/MCF_US_003']},

        {key : 'cf7',name:'영업기회 알림',                link : '/cf/MCF_AM_001',id:'M007M007M001',access:false},
        {key : 'cf7',name:'메일발신 이력',                link : '/cf/MCF_AM_002',id:'M007M007M002',access:false},
        {key : 'cf8',name:'배치 프로시저 관리',           link : '/cf/MCF_BT_001',id:'M007M008M001',access:false},
        {key : 'cf8',name:'스케줄러 이력 조회',           link : '/cf/MCF_BT_003',id:'M007M008M002',access:false},
        {key : 'cf8',name:'배치 결과 조회',           link : '/cf/MCF_BT_004',id:'M007M008M003',access:false},
        {key : 'cf8',name:'상품오류기입 조회',           link : '/cf/MCF_BT_005',id:'M007M008M004',access:false},
        {key : 'cf9',name:'News&Notice등록/수정', link : '/cf/MCF_NT_001',id:'M007M009M001',access:false},
        {key : 'cf9',name:'News&Notice조회', link : '/cf/MCF_NT_002',id:'M007M009M002',access:false},

    ],
    keyStatus : ''
  }

  const menuList = Object.keys(data).filter(name => name.includes('Depth'))
  menuList.forEach((depth)=>{
    data[depth].forEach((item)=>{
      if (userStore.user) {
        item.access = item.id ? userStore.user.mnUrl.includes(item.id) : true
      }
    })
  })


  Object.values(data).forEach(datum => {
    Object.values(datum).forEach(item => {
      if (item.link.toLowerCase() === route.path.toLowerCase()) {
        if(userStore.user && !item.access){
          alert('접근 불가한 페이지입니다.')
          router.push('/')
          return
        }
        data.keyStatus = item.key
      }
    })
  })

  return data
})
function isCollapseShow(menuList){
  if(menuList){
    let pathNm = location.pathname.split('/')[location.pathname.split('/').length-1]
    return menuList.includes(pathNm)
  }

}

function checkActive(item){
  let activeFlag = false
  if(item.activeLink){
    activeFlag = item.activeLink.includes(location.pathname)
  }else{
    activeFlag = item.link === location.pathname
  }

  return activeFlag ? 'route-active' : ''
}

</script>